import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const PaymentContractor = () => {
  return (
    <SettingsMetaData propertyName={"paymentTerms"} viewPropertyName={"Payment Terms"} />
  );
};
export default PaymentContractor;